import styled, { css } from 'styled-components'

import { BREAK_POINT_LG } from '@CSSVars/variables'
import { PRIMARY_DARK_COLOR } from '@CSSVars/colors'

import FilterTag from './FilterTag'


const tagMixin = css`
  display: inline-flex;
  align-items: center;
  min-height: 30px;
  background-color: ${PRIMARY_DARK_COLOR};
  border-radius: 10px;
  padding: 5px;
  margin: 0 3px 3px 0;
  cursor: default;
  div {
    color: white;
    font-size: 12px;
  }
  svg {
    display: none;
    fill: white;
  }

  ${({ isRemovable }) => (
    isRemovable ?
      `
        position: relative;
        padding-right: 32px;
        cursor: pointer;

        position: relative;

        && {

          svg {
            display: block;
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);

          }
        }

        sup {
          color: white;
          padding-right: 5px;
        }

        @media screen and (max-width: 47.9em) {
          display: inline-flex;
        }
      ` : ''
  )};

  @media screen and (max-width: ${BREAK_POINT_LG}) {
    height: 30px;
    width: fit-content;
    margin: 4px 7px 3px 0;
    ${({ autoCompleteTag, showAutoCompleteMobileTag }) => autoCompleteTag && showAutoCompleteMobileTag && `
      background-color: ${PRIMARY_DARK_COLOR};

      div {
        color:white;
        font-size: 12px;
        line-height: 22px;
      }
      padding: 12px 32px 12px 12px;
      text-align: left;

      && {

        svg {
          fill: white;
        }
      }
    `}
  }
`

export const _Tag = styled(FilterTag)`
  ${tagMixin};
  ${({ noCloseIcon }) => (noCloseIcon && `
      .closeIcon {
        display: none !important;
      }
        padding: 10px !important;
    `)}

`

// This is being imported to BuildingTag Component
export const _BuildingTag = styled.div`
  ${tagMixin};
`
